import { render } from "./UserSmallCard.vue?vue&type=template&id=3087ac34&scoped=true&ts=true"
import script from "./UserSmallCard.vue?vue&type=script&lang=ts"
export * from "./UserSmallCard.vue?vue&type=script&lang=ts"

import "./UserSmallCard.vue?vue&type=style&index=0&id=3087ac34&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3087ac34"]])

export default __exports__